import { apiV2Client } from '../../../services/apiClient';
import { AssessmentResponseState, CompleteAssessmentResponseRequest } from '../models/assessmentResponse';

export const completeAssessmentResponse = (
  request: CompleteAssessmentResponseRequest
): Promise<AssessmentResponseState> => {
  return apiV2Client
    .post<AssessmentResponseState>('/assessment/command/CompleteAssessmentResponse', request)
    .then(({ data }) => data);
};
